/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const isValueExist = (value: any): boolean => value !== undefined && value !== null;

const isPositiveNumber = (value?: number | string | null): boolean => typeof value === 'number' && !isNaN(value) && value > 0;

const isPositiveNumberOrZero = (value?: number | string | null): boolean => typeof value === 'number' && !isNaN(value) && value >= 0;

export {
    isValueExist,
    isPositiveNumber,
    isPositiveNumberOrZero,
};
